import {defineRouting} from 'next-intl/routing';
import {createNavigation} from 'next-intl/navigation';

const IS_DEV = process.env.NODE_ENV === 'development';
export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en', 'fr', 'ar', 'it', 'ru', 'de', 'sv', 'nl', 'es', 'pt'],

  // Used when no locale matches
  defaultLocale: 'en',

 localePrefix: 'never',
 domains: IS_DEV
    ? [
        { domain: 'localhost',    defaultLocale: 'en', locales: ['en'] },
        { domain: 'fr.localhost', defaultLocale: 'fr', locales: ['fr'] },
        { domain: 'ar.localhost', defaultLocale: 'ar', locales: ['ar'] },
        { domain: 'it.localhost', defaultLocale: 'it', locales: ['it'] },
        { domain: 'ru.localhost', defaultLocale: 'ru', locales: ['ru'] },
        { domain: 'de.localhost', defaultLocale: 'de', locales: ['de'] },
        { domain: 'sv.localhost', defaultLocale: 'sv', locales: ['sv'] },
        { domain: 'nl.localhost', defaultLocale: 'nl', locales: ['nl'] },
        { domain: 'es.localhost', defaultLocale: 'es', locales: ['es'] },
        { domain: 'pt.localhost', defaultLocale: 'pt', locales: ['pt'] },
      ]
    : [
        { domain: 'padelmasterthegame.com',    defaultLocale: 'en', locales: ['en'] },
        { domain: 'fr.padelmasterthegame.com', defaultLocale: 'fr', locales: ['fr'] },
        { domain: 'ar.padelmasterthegame.com', defaultLocale: 'ar', locales: ['ar'] },
        { domain: 'it.padelmasterthegame.com', defaultLocale: 'it', locales: ['it'] },
        { domain: 'ru.padelmasterthegame.com', defaultLocale: 'ru', locales: ['ru'] },
        { domain: 'de.padelmasterthegame.com', defaultLocale: 'de', locales: ['de'] },
        { domain: 'sv.padelmasterthegame.com', defaultLocale: 'sv', locales: ['sv'] },
        { domain: 'nl.padelmasterthegame.com', defaultLocale: 'nl', locales: ['nl'] },
        { domain: 'es.padelmasterthegame.com', defaultLocale: 'es', locales: ['es'] },
        { domain: 'pt.padelmasterthegame.com', defaultLocale: 'pt', locales: ['pt'] },
      ],



      
  pathnames :{
    "/": "/",
    "/login": "/login",
    "/contact-us":"/contact-us",
    "/auth/popup-success/": "/auth/popup-success/",
    "/account/report":"/account/report",
    "/account/balance":"/account/balance",
    "/account/billing":"/account/billing",
    "/account/payment":"/account/payment",
    "/pricing": "/pricing",
    "/account/offer": {
      en: "/account/offer",
      fr: "/compte/offer",
      ar: "/الحساب/العروض",
      nl: "/account/offers",
      de: "/konto/angebote",
      pt: "/conta/ofertas",
      sv: "/konto/erbjudanden",
      ru: "/аккаунт/предложения",
      it: "/account/offerte",
      es: "/cuenta/ofertas",
    },
    "/account": {
      en: "/account",
      fr: "/compte",
      ar: "/الحساب",
      nl: "/account",
      de: "/konto",
      pt: "/conta",
      sv: "/konto",
      ru: "/аккаунт",
      it: "/account",
      es: "/cuenta",
    },
    "/account/address": {
      en: "/account/address",
      fr: "/compte/adresse",
      ar: "/الحساب/العنوان",
      nl: "/account/adres",
      de: "/konto/adresse",
      pt: "/conta/endereco",
      sv: "/konto/adress",
      ru: "/аккаунт/адрес",
      it: "/account/indirizzo",
      es: "/cuenta/direccion",
    },
    "/privacy-policy": {
      en: "/privacy-policy",
      fr: "/politique-de-confidentialite",
      ar: "/سياسة-الخصوصية",
      nl: "/privacybeleid",
      de: "/datenschutz",
      pt: "/politica-de-privacidade",
      sv: "/integritetspolicy",
      ru: "/политика-конфиденциальности",
      it: "/politica-sulla-privacy",
      es: "/politica-de-privacidad",
    },

    "/login-signin": {
      en: "/login-signin",
      fr: "/connexion",
      ar: "/تسجيل-الدخول",
      nl: "/inloggen",
      de: "/anmelden",
      pt: "/entrar",
      sv: "/logga-in",
      ru: "/вход",
      it: "/accedi",
      es: "/iniciar-sesion",
    },
    "/reset-email": {
      en: "/reset-email",
      fr: "/reinitialiser-email",
      ar: "/إعادة-تعيين-البريد",
      nl: "/reset-email",
      de: "/email-zurücksetzen",
      pt: "/redefinir-email",
      sv: "/aterstall-e-post",
      ru: "/сброс-почты",
      it: "/reimposta-email",
      es: "/restablecer-correo",
    },
    "/reset-password": {
      en: "/reset-password",
      fr: "/reinitialiser-mot-de-passe",
      ar: "/إعادة-تعيين-كلمة-المرور",
      nl: "/reset-wachtwoord",
      de: "/passwort-zurücksetzen",
      pt: "/redefinir-senha",
      sv: "/aterstall-losenord",
      ru: "/сброс-пароля",
      it: "/reimposta-password",
      es: "/restablecer-contrasena",
    },
    "/terms-and-conditions": {
      en: "/terms-and-conditions",
      fr: "/conditions-generales",
      ar: "/الشروط-والأحكام",
      nl: "/algemene-voorwaarden",
      de: "/agb",
      pt: "/termos-e-condicoes",
      sv: "/villkor",
      ru: "/условия",
      it: "/termini-e-condizioni",
      es: "/terminos-y-condiciones",
    },
      "/refund-policy": {
      en: "/refund-policy",
      fr: "/politique-de-remboursement",
      ar: "/سياسة-الاسترداد",
      nl: "/terugbetalingsbeleid",
      de: "/rueckerstattungsrichtlinie", // or "/rückerstattungsrichtlinie"
      pt: "/politica-de-reembolso", // or "/política-de-reembolso"
      sv: "/aterbetalningspolicy", // or "/återbetalningspolicy"
      ru: "/politika-vozmeshcheniya", // or "/политика-возмещения"
      it: "/politica-di-rimborso",
      es: "/politica-de-reembolso", // or "/política-de-reembolso"
    }
    
   
  },
  
});


export type Locale = (typeof routing.locales)[number];
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);

export type AppPathname = keyof typeof routing.pathnames;
export type AppLocale = typeof routing.locales[number];

